'use strict';

exports.decode = exports.parse = require('./decode');
exports.encode = exports.stringify = require('./encode');



//////////////////
// WEBPACK FOOTER
// /home/dani/kaiwa/~/querystring/index.js
// module id = 853
// module chunks = 2